import React from "react";
import styles from "./AuthFooter.less";
const AuthFooter = (props) => {
    return (React.createElement("div", { className: styles.bottomText }, props.children));
};
export default AuthFooter;
